import { IApiServiceContext, ApiServiceContextState } from '../context/ApiServiceContext';
import { useContext } from 'react';
import {IPaginationContext, PaginationContextState} from "../context/PaginationContext";

export const usePagination = () => useContext<PaginationContextState>(IPaginationContext);